export const INIT_NOTIFICATION = "NOTIFCATION";
export const RATE_INTERACTION = "RATE_INTERACTION";
